import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { DateIcon } from '../../vectors/index';

type SelectDateModalProps = {
  isOpen: boolean;
  disablePast?: boolean;
  handleClose: () => void;
  date: Dayjs | string | null;
  setDate: Dispatch<SetStateAction<Dayjs | string | null>>;
};

const SelectDateModal: FC<SelectDateModalProps> = ({
  isOpen,
  handleClose,
  date,
  setDate,
  disablePast,
}) => {
  const [checkdate, setCheckDate] = useState<Dayjs | string | null>(null);

  const handleSubmit = () => {
    setDate(checkdate)
    handleClose()
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <br />
        <DateIcon />
        <br />
        <Typography variant="h4" sx={{ p: 3 }}>
          Select date
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DateCalendar
          disableFuture={disablePast ? false : true}
          disablePast={disablePast ?? false}
          value={date}
          onChange={(value) => {
            setCheckDate(value);
          }}
        />
        <Button sx={{ mb: 1, textAlign: "center" }} fullWidth disabled={!checkdate} variant="contained" onClick={handleSubmit}>
          Submit
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SelectDateModal;
